/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageSlot = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 3v18H2V3zm-2 2H4v14h16zM7 15v2H5v-2zm12 0v2h-2v-2zm-8 0v2H9v-2zm4 0v2h-2v-2zm-8-4v2H5v-2zm12 0v2h-2v-2zM7 7v2H5V7zm4 0v2H9V7zm4 0v2h-2V7zm4 0v2h-2V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPageSlot as PageSlot };
